<template>
  <div class="brand-story">
    <section class="brand-story__hero" aria-labelledby="brand-story-heading">
      <div class="brand-story__hero-inner">
        <div class="brand-story__copy">
          <h1 id="brand-story-heading" class="brand-story__title">
            关于 PAXA 湃萨
          </h1>
          <p class="brand-story__lead">一个为女性感官而生的耳机品牌</p>
        </div>
        <div class="brand-story__visual">
          <img
            class="brand-story__img"
            :src="heroImgUrl"
            alt="PAXA 品牌故事主视觉"
          />
        </div>
      </div>
    </section>

    <section class="brand-story__body" aria-label="品牌介绍正文">
      <div class="brand-story__body-inner">
        <p
            v-for="(para, index) in paragraphs"
            :key="index"
            class="brand-story__para"
        >
          {{ para }}
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import moteImg from '@/assets/mote.png'

export default {
  name: 'BrandStoryPage',
  data() {
    return {
      /** 品牌故事页右侧主图：src/assets/mote.png */
      heroImgUrl: moteImg,
      /** 正文段落（与设计稿一致，便于后续接 CMS） */
      paragraphs: [
        'PAXA 湃萨是面向当代女性的智能音频品牌。我们相信，科技可以是温暖的，美也可以是有功能的——耳机不该只是参数表上的冰冷物件，而应融入日常，成为气质与态度的一部分。',
        '「PAXA」之名，源于「Pax」（平和、安宁）与「Aura」（氛围、灵光）的融合：我们希望每一次聆听，都是一段与自己相处的安静时刻，也是环绕周身的一抹柔和气场。',
        '从开放式可穿戴立体声（OWS）到真无线立体声（TWS），我们在声学方案与佩戴工学上持续投入，让长时间佩戴依然轻盈、稳固、自然，让「戴上即忘记」成为默认体验，而非口号。',
        '当技术化作流淌的旋律、化作贴合耳廓的舒适触感，它便不再是远离生活的术语，而是你可信赖的日常陪伴。'
      ]
    }
  },
  mounted() {
    console.info('[BrandStoryPage] 品牌故事页已挂载，主图:', this.heroImgUrl)
  }
}
</script>

<style scoped>
.brand-story {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
}

/* 首屏：顶贴 ActionBar、右贴边 + cover/top right，才能还原素材自带的「裁切」构图 */
.brand-story__hero {
  width: 100%;
  height: 640px;
  box-sizing: border-box;
  background: #ececec;
  overflow: hidden;
}

.brand-story__hero-inner {
  height: 100%;
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.12fr);
  align-items: stretch;
  column-gap: clamp(40px, 5vw, 88px);
  row-gap: 0;
  /* 无上 padding：主视觉顶边与顶栏下沿对齐，裁切关系才成立；左右留白由文案列自身 padding 承担 */
  padding: 0;
  box-sizing: border-box;
}

.brand-story__copy {
  max-width: 34rem;
  padding: clamp(28px, 4vh, 56px) clamp(0px, 2vw, 24px) clamp(24px, 3vh, 40px)
    clamp(32px, 4vw, 64px);
  align-self: center;
  box-sizing: border-box;
}

.brand-story__title {
  margin: 0 0 clamp(12px, 2vh, 20px);
  font-size: clamp(32px, 3.6vw, 48px);
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #000;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.brand-story__lead {
  margin: 0;
  font-size: clamp(16px, 1.25vw, 20px);
  font-weight: 400;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.55);
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.brand-story__visual {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}

/* 视口宽于内容区时右栏拉出到屏右缘，裁切边与屏边一致 */
@media (min-width: 1440px) {
  .brand-story__visual {
    margin-right: calc((100vw - 1440px) / -2);
  }
}

.brand-story__img {
  width: 100%;
  height: 100%;
  min-width: 100%;
  object-fit: cover;
  object-position: top right;
  display: block;
}

.brand-story__body {
  width: 100%;
  padding: clamp(48px, 8vh, 120px) 24px clamp(80px, 12vh, 160px);
  box-sizing: border-box;
}

.brand-story__body-inner {
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}

.brand-story__para {
  margin: 0 0 clamp(20px, 3vh, 32px);
  font-size: clamp(15px, 1.1vw, 17px);
  line-height: 1.85;
  color: rgba(0, 0, 0, 0.78);
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.brand-story__para:last-child {
  margin-bottom: 0;
}

@media (max-width: 960px) {
  .brand-story__hero {
    height: auto;
  }

  .brand-story__hero-inner {
    grid-template-columns: 1fr;
    padding: 0;
  }

  .brand-story__copy {
    max-width: none;
    padding-left: 24px;
    padding-right: 24px;
    order: 2;
    text-align: center;
  }

  .brand-story__visual {
    order: 1;
    justify-content: center;
    margin-right: 0;
    height: min(52vh, 420px);
  }

  .brand-story__img {
    width: 100%;
    height: 100%;
    object-position: top center;
  }
}
</style>
